import { render } from "./MyCareer.vue?vue&type=template&id=4f4dbaa7&scoped=true"
import script from "./MyCareer.vue?vue&type=script&lang=js"
export * from "./MyCareer.vue?vue&type=script&lang=js"

import "./MyCareer.vue?vue&type=style&index=0&id=4f4dbaa7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4dbaa7"]])

export default __exports__